define([], function () {

    return function (config, element) {
        const activeTitleClass   = 'tab__title--active',
            activeContentClass = 'tab__content--active',
            children           = Array.from(element.children),
            content_tabs       = document.querySelectorAll('.tab__content');

        children.forEach(item => {
            const tabTitle = item.dataset.tab;

            if (item.classList.contains('tab__title')) {
                item.addEventListener('click', () => {

                    children.forEach((item) => {
                        item.classList.remove(activeTitleClass);
                    });

                    content_tabs.forEach((item) => {
                        item.classList.remove(activeContentClass);
                        if(item.dataset.content == tabTitle)
                        {
                            item.classList.add(activeContentClass);
                        }
                    });

                    item.classList.add(activeTitleClass);

                    if(window.matchMedia("(max-width: 500px)").matches) {
                        document.querySelector(`.${activeTitleClass}`).scrollIntoView({behavior: "smooth"});
                    }
                });
            }
        });
    }
});
